import { AnimationWithSize } from './AnimationWithSize';

export const MindMap = () => (
	<AnimationWithSize src="https://dam-cdn.atl.orangelogic.com/AssetLink/28nn7y04kk8jwnv45hr78c2d8o53510t.riv" />
);
